<div class="wrap">
    <div class="center p-t-10 p-b-3 p-t-5-m p-t-4-s p-b-0-s m-t-2"
         cy-searchResultSummary>
        <icms-outlet-block [name]="'Search Page - results components'"
                           [variant]="'search-view-page-results'"></icms-outlet-block>

        @if(useKlevu) {
        <search-banner [context]="'searchPage'"
                       class="m-b-5-x m-b-5-l"
                       [term]="result?.term"></search-banner>
        }
        @switch (hasProductResults()) {
        @case (true) {

        <p class="h2 p-t-4-m p-t-4-s p-b-6-s">
            {{resultTitle | translate : result.term}}</p>

        }
        @case (false) {
        <p class="m-t-8 m-b-6"
           sizeClass="XL:h2, MS:h3">
            {{noResultsTitle| translate : result?.term }}
        </p>
        <icms-outlet-block name="Search Page - no results top components"
                           variant="search-view-page-no-results-top"></icms-outlet-block>
        @if(noResultsText) {
        <p class="text center">
            {{noResultsText| translate : result?.term }}
            }
            <icms-outlet-block name="Search Page - no results components"
                               variant="search-view-page-no-results"></icms-outlet-block>
            }
            }
    </div>
</div>
@if(hasProductResults()) {
<div>
    <ng-container *ngComponentOutlet="
                            listingOutlet.component;
                            inputs: listingOutlet.inputs;
                            " />
</div>
}
